export default [
   'Disetujui',
   'Terkirim ke BKPM',
   'Terkirim ke BKPM (LKPM Daerah)',
   'Perlu Perbaikan',
   'Sudah Diperbaiki',
]
